/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection, ChangeableButtonBg, Button } from 'helpers/components';

import { ButtonStyles } from '../UI/UI';

const Article = ({ handleScroll }) => {
  return (
    <ChangeableBackgroundSection
      id="article-wrapper-bg"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <ArticleContainer>
          <Image>{useImg('article1.png', 'article1')}</Image>
          <Title>{useText('article__title', true)}</Title>
          <Text>{useText('article__text', true)}</Text>
          <ChangeableButtonBg
            id="article-button-background"
            defaultColor="#1d9752"
            buttonContainerCss={buttonContainerCss}
          >
            <Button
              buttonCss={buttonStyles}
              clickHandler={handleScroll}
            >
              {useText('article__btn', true)}
            </Button>
          </ChangeableButtonBg>
        </ArticleContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const buttonContainerCss = css`
  width: 100%;
`;

const Wrapper = styled.section`
  @media ${DESKTOP} {
    margin-top: -20px;
    padding: 0 0 80px;
  }

  @media ${TABLET} {
    padding: 0px 0 46px;
  }

  @media ${MOBILE} {
    padding: 0px 0 40px;
  }
`;

const ArticleContainer = styled(Container)`
  @media ${DESKTOP} {
    padding-inline-end: 405px;
  }

  @media ${MOBILE} {
    max-width: 340px;
  }
`;

const Title = styled.div`
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 36px;
  line-height: 45px;
  color: #000000;

  @media ${TABLET} {
    margin-bottom: 23px;
    font-size: 34px;
    line-height: 43px;
  }

  @media ${MOBILE} {
    margin-bottom: 24px;
    font-size: 22px;
    line-height: 32px;
  }
`;

const Text = styled.div`
  margin-bottom: 44px;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  text-align: right;
  color: #000000;

  p:not(:last-child) {
    margin-bottom: 24px;
  }

  @media ${TABLET} {
    margin-bottom: 46px;
    font-size: 17px;
    line-height: 31px;
  }

  @media ${MOBILE} {
    font-size: 15px;
    line-height: 26px;
  }
`;

const Image = styled.div`
  margin-bottom: 29px;

  img {
    display: block;
    max-width: 100%;
    width: 100%;
    height: auto;
  }
`;

const buttonStyles = css`
  ${ButtonStyles}

  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media ${TABLET} {
    font-size: 16px;
    line-height: 16px;
    padding: 19px;
    max-width: 385px;
  }

  @media ${MOBILE} {
    max-width: 300px;
    font-size: 16px;
    line-height: 16px;
    padding: 20px;
  }
`;

Article.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default Article;
